import type { Nationality } from '@/shared/types/api.types'
import { TravelDirection } from '@/shared/types/common.types'

export type TripType = 'SINGLE' | 'MULTI'

export enum PreferredCoinsReward {
  SPEND = 'spend',
  EARN = 'earn',
}

export interface State {
  email: string | null
  phone: string | null
  maskedPhone: string | null
  firstName: string | null
  familyName: string | null
  dateOfBirth: Date | null
  nationality: Nationality | null
  passportNumber: string | null
  emiratesId: string | null
  civilIdExpiryDate: Date | null
  destination: { id: string; name: string }[]
  residenceCountry: { id: string; name: string } | null
  departureDate: Date | null
  returnDate: Date | null
  tripType: TripType
  prevTripType: TripType
  adultsCount: number
  childrenCount: number
  promocode: string | null
  selectedPlan: string | null
  withWinterSport: boolean
  withCovid: boolean
  withCyber: boolean
  countryCode: string | null
  lastFlowDirection?: TravelDirection | null
  activeInsuredTravelersSubPage?: 'edit' | 'add'
  paymentMethod: string | null
  isAffinity: boolean
  redirectURL: string | null
  isHeroSection: boolean
  gender: string | null
  preferredReward: PreferredCoinsReward
}
